import React from "react";
import { BlockVariant, TextCustomizations } from "src/types";

import sponsorsBronzePreview from "@/components/editor/themes/crosby/blocks/sponsors/preview-bronze.jpg";
import { DEFAULT_TIER_TITLES } from "@/features/sponsors/sponsors-reducer";

export function sponsorWidgetList(Component: React.ComponentType<any>) {
  return Object.entries(DEFAULT_TIER_TITLES)
    .filter(([layout]) => /tier \d/.test(layout))
    .map(([layout, title]) => ({
      displayName:
        "selection-menu.selection.blocks.synced-sponsors-custom-tier",
      stringMap: (tc: TextCustomizations) => ({
        tier:
          tc?.custom_text?.sponsors?.[layout.replace(" ", "-")] ||
          layout.replace("t", "T"),
      }),
      previewImage: sponsorsBronzePreview,
      variant: BlockVariant.SYNCED_EXT,
      Component: () => (
        <Component
          {...{
            title: title,
            layout: layout,
          }}
        />
      ),
    }));
}
